import React from 'react';
import { useAuth } from "util/auth";
import {useSelector} from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import Dropdown from 'react-bootstrap/Dropdown'
import Modal from 'react-bootstrap/Modal'
import Auth from 'components/Auth'
import AvatarButton from 'components/CustomButtons/AvatarButton'
import { useLocation, useHistory, useRouter } from 'util/router'
import {sendNewError} from 'util/slackbot'
import Bugsnag from '@bugsnag/js'
import { useCookies } from 'react-cookie'
import {REFERRAL_USER_ID, REFERRAL_WIDGET_NAME} from 'pages/referralInvitation'

function LoginSignupForm(props) {

    const [cookies, setCookie, removeCookie] = useCookies([REFERRAL_USER_ID, REFERRAL_WIDGET_NAME]);

    const router = useRouter();

    const auth = useAuth()
    const {onComplete, titleCopy} = props
    const [status, setStatus] = React.useState({})
    
    const [mode, setMode] = React.useState(props.mode ?? 'signin')

    const handleFacebook = () => {
        setStatus({type: 'pending', message: ""})
        auth.signinWithFacebook()
            .then(res => {
                setStatus({type: 'success', message: ""})
                // onHide()
                onComplete()
            })
            .catch(err => {
                if (err.message) {
                    // setStatus({type: 'error', message: err.message})
                    setStatus({type: 'error', message: "Login failed. Please try again"})
                } else {
                    setStatus({type: 'error', message: "There was an error signing in"})
                }
            })
    }

    const handleSubmit = async ({ name, email, pass }) => {
        if (mode === 'signin') {
            setStatus({type: 'pending', message: ""})
            auth.signin(email, pass)
                .then(res => {
                    setStatus({type: 'success', message: ""})
                    // onHide()
                    onComplete()
                })
                .catch(async err => {

                    
                    if (err?.code === `auth/wrong-password`) {
                        setStatus({type: 'error', message: (
                            <div>
                                <p>Oops, it looks like your password is incorrect.</p>
                                <p>If you forgot password, reset it <a target="_blank" href="https://sutrapro.com/forgotpass">here</a></p>
                            </div>
                        )})
                    } else if (err?.code === `auth/user-not-found`) {
                        setStatus({type: 'error', message: (
                            <div>
                                <p>Oops, it looks like this account does not exist.</p>
                            </div>
                        )})

                    } else if (err.message) {
                        setStatus({type: 'error', message: err.message})
                        Bugsnag.notify(new Error(err))
                        await sendNewError(JSON.stringify({
                            location: "Sign in form",
                            error: {...err},
                            name: name,
                            email: email
                        }))
                    } else {
                        setStatus({type: 'error', message: "There was an error signing in"})
                        Bugsnag.notify(new Error(err))
                        await sendNewError(JSON.stringify({
                            location: "Sign in form",
                            error: {...err},
                            name: name,
                            email: email
                        }))
                    }
                })

                // cookies.user
        } else if (mode === 'signup') {

            const referralUserId = cookies[REFERRAL_USER_ID]
            const referralWidgetName = cookies[REFERRAL_WIDGET_NAME]
            const isStudio = router.query.secret === 'studios-only'
            const isInstructor = isStudio || router.query.secret === 'instructors-only'
            
            setStatus({type: 'pending', message: ""})
            auth.signupWithName(name, email, pass, isInstructor, isStudio, referralUserId, referralWidgetName)
                .then(res => {
                    setStatus({type: 'success', message: ""})
                    // onHide()
                    onComplete()
                })
                .catch(async err => {
                    Bugsnag.notify(new Error(err))
                    await sendNewError(JSON.stringify({
                        location: "Sign up form",
                        error: {...err},
                        name: name,
                        email: email
                    }))
                    if (err?.code === `auth/email-already-in-use`) {
                        setStatus({type: 'error', message: (
                            <div>
                                <p>Oops, it looks like your email has been used to sign up with another <a target="_blank" href="https://sutra.fit">Sutra</a> instructor.</p>
                                <p>If you forgot password, reset it <a target="_blank" href="https://sutrapro.com/forgotpass">here</a></p>
                            </div>
                        )})
                    } else if (err.message) {
                        setStatus({type: 'error', message: err.message})
                    } else {
                        setStatus({type: 'error', message: "There was an error signing up. Please refresh and try again."})
                    }
                })
        } else {
            await sendNewError(JSON.stringify({
                location: "Sign in/up form",
                name: name,
                email: email
            }))
            window.alert("There was an issue in the sign up process")
        }
    }
    
    return (
        <>
            {auth.userData?.email ? (
                <div className="alert alert-primary text-center primaryColor" role="alert">
                    {`You're logged in as ${auth.userData?.email}`}
              </div>
            ) : (
            <>
                <div>
                    {router.query.partner_name && (
                        <h4 className="text-center">{decodeURIComponent(router.query.partner_name)} invited you to collab on Sutra</h4>
                    )}
                    {!props.hideTitle && (
                        <h6 className="text-center">{titleCopy ? titleCopy : "Login"}</h6>
                    )}
                    {mode === 'signin' && (
                        <div className="w-100 d-flex d-row justify-content-center align-items-center mb-3">
                            <p className="m-0">Don't have an account?&nbsp;</p>
                            <button className="btn btn-link primaryColor p-0" onClick={() => setMode('signup')}>Sign up</button>
                        </div>
                    )}
                    {mode === 'signup' && (
                        <div className="w-100 d-flex d-row justify-content-center align-items-center mb-3">
                            <p className="m-0">Already have an account?&nbsp;</p>
                            <button className="btn btn-link primaryColor p-0" onClick={() => setMode('signin')}>Sign in</button>
                        </div>
                    )}

                </div>
                <Auth
                mode={mode}
                onSubmit={handleSubmit}//{onLoginSubmit}
                // onFacebook={handleFacebook}
                status={status}//{loginStatus} can be {type: 'error', message: 'some error message'} or danger, pending, success
                buttonText={mode === 'signin' ? "Sign in" : "Sign up"}
                inputSize={props.inputSize ? props.inputSize : "md"}
                primaryColor="primaryColor"
                ></Auth>
                {mode === 'signup' && (
                    <p className="text-center" style={{fontSize: 'smaller'}}>By entering your email you agree to Sutra's <a className="primaryColor" target="_blank" href="https://www.sutra.fit/terms">Terms of Service</a> and <a className="primaryColor" target="_blank" href="https://www.sutra.fit/privacy">Privacy Policy</a></p>
                )}
                
            </>
            )}
            
        </>
    )
}

export {LoginSignupForm}

function LoginSignupModal(props) {

    

    
    const {show, onHide} = props
    const [mode, setMode] = React.useState(props.mode) // signin / signup
    

    // var viewModel = {
    //     title: mode === 'signin' ? "Login" : "Create an account",
    //     showTerms: mode === 'signup',
    // }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                {/* <Modal.Title>{viewModel.title}</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
                <LoginSignupForm
                mode={props.mode}
                onComplete={onHide}
                />
                
            </Modal.Body>
            
        </Modal>
    )
}

function AccountButton(props) {

    const auth = useAuth()
    const location = useLocation()
    const history = useHistory()
    const [showLogin, setShowLogin] = React.useState(false)

    const isLoading = useSelector(state => state.user.isLoading)
    const user = useSelector(state => state.user.userData)

    if (isLoading) {
        return (<Spinner
        animation="border"
        size="sm"
        aria-hidden={true}
        className="ml-2"
      >
        <span className="sr-only">Loading</span>
      </Spinner>)
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
          href=""
          ref={ref}
          onClick={(e) => {
            e.preventDefault();
            onClick(e);
          }}
        >
          {children}
        </a>
    ));
    return (
        <div className={props.className}>
            <LoginSignupModal
            mode='signin'
            show={showLogin}
            onHide={() => setShowLogin(false)}
            />

            {auth.userData && (
                <Dropdown>
                    <Dropdown.Toggle  as={CustomToggle} id="dropdown-basic">
                        <AvatarButton
                        imageUrl={auth.userData.profileImageUrl}
                        name={auth.userData.firstName}
                        />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>

                    <Dropdown.Item className="primaryColor" onClick={() => {
                            history.push(`/${props.widget}/my-profile`)
                        }}>Profile</Dropdown.Item>

                        <Dropdown.Item className="primaryColor" onClick={() => {
                            history.push(`/${props.widget}/my-bookings`)
                        }}>Bookings</Dropdown.Item>

                        <Dropdown.Item className="primaryColor" onClick={() => {
                            history.push(`/${props.widget}/my-purchases`)
                        }}>Purchases</Dropdown.Item>

                        <Dropdown.Divider />
                        <Dropdown.Item className="primaryColor" onClick={() => auth.signout()}>Logout</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            )}

            {!auth.userData && (
                <button 
                className="btn btn-outline-primary my-2 my-sm-0 primaryColor" 
                type="button"
                onClick={() => setShowLogin(true)}>
                    Login
                </button>
            )}


        </div>
        
    )
}

export default AccountButton